// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"ComplexHeader_headerWrapper__1OzLw"};